import { Link } from '@/router';
import { categories } from '@/mocks/mangaData';

interface CategoryNavProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryNav({ activeCategory, onCategoryChange }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onCategoryChange(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}